import React, { useEffect, useState } from "react";
import { ButtonWithLoader } from "../../general/ButtonWithLoader/ButtonWithLoader";
import { AccountingReportFiltersForm } from "../AccountingReportFiltersForm";
import { useAccountingTabContext } from "../useAccountingTab";
import { LoaderOnInitialLoading } from "../../general/LoaderOnInitialLoading";
import { useUser } from "../../../hooks/useUser";
import { UserType } from "../../../common/types/user";
import { useTrialBalanceQuery } from "../../../api/accountingReports.api";
import { TrialBalancePageContent } from "./TrialBalancePageContent";
import { useTrialBalanceDownload } from "./trialBalanceDownload/useTrialBalanceDownload";

export const TrialBalancePage: React.FC = () => {
    const { type } = useUser();
    const { filters, setFilters, selectedEntity } = useAccountingTabContext();
    const [generationDate, setGenerationDate] = useState(new Date());

    const trialBalance = useTrialBalanceQuery(filters);

    useEffect(() => {
        if (trialBalance.data) {
            setGenerationDate(new Date());
        }
    }, [trialBalance.data, setGenerationDate]);

    const { download, downloading } = useTrialBalanceDownload(
        trialBalance.data,
    );

    return (
        <>
            <AccountingReportFiltersForm
                filters={filters}
                setFilters={setFilters}
                hideSearch
                additionalButtons={
                    <ButtonWithLoader
                        onClick={() =>
                            selectedEntity &&
                            download(selectedEntity, filters.endDate)
                        }
                        loading={downloading}
                        variant="secondary"
                    >
                        Download (.xlsx)
                    </ButtonWithLoader>
                }
                selectExactDays
                requireReportsReady={type === UserType.REGULAR}
            />
            {selectedEntity && (
                <LoaderOnInitialLoading queryResult={trialBalance}>
                    {trialBalance.data && selectedEntity && (
                        <TrialBalancePageContent
                            data={trialBalance.data}
                            filters={filters}
                            entity={selectedEntity}
                            generationDate={generationDate}
                        />
                    )}
                </LoaderOnInitialLoading>
            )}
        </>
    );
};
